import { Control } from 'react-hook-form'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { ITEM_TYPES } from '../constants'
import type { NotificationItemFormData } from '../types'

interface ItemTypeFieldProps {
	control: Control<NotificationItemFormData>
}

export default function ItemTypeField({ control }: ItemTypeFieldProps) {
	return (
		<FormField
			control={control}
			name="type"
			render={({ field }) => (
				<FormItem>
					<FormLabel required>ประเภทรายการ</FormLabel>
					<Select value={field.value} onValueChange={field.onChange}>
						<FormControl>
							<SelectTrigger>
								<SelectValue placeholder="เลือกประเภทรายการ" />
							</SelectTrigger>
						</FormControl>
						<SelectContent>
							{ITEM_TYPES.map((type) => (
								<SelectItem key={type.value} value={type.value}>
									{type.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
